import { AllocationTypeEnum } from '@msc-b2c/interfaces/enums';

export const slotsMyMSCResponseMock = {
  slots: [
    {
      id: '166837',
      isAvailable: true,
      startTime: '12:00:00',
      endTime: '13:00:00',
      isAssigned: true,
      allocationType: AllocationTypeEnum.INDIVIDUAL,
    },
    {
      id: '166838',
      isAvailable: false,
      startTime: '13:00:00',
      endTime: '14:00:00',
      isAssigned: false,
      allocationType: AllocationTypeEnum.GROUP,
    },
    {
      id: '166839',
      isAvailable: true,
      startTime: '14:00:00',
      endTime: '15:00:00',
      isAssigned: false,
      allocationType: AllocationTypeEnum.INDIVIDUAL,
    },
  ],
};
